import { useContext, useState } from 'react'

import Checkbox from '../basic-components/Checkbox'
import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Footer, Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'
import List from '../basic-components/List'
import ListItem from '../basic-components/ListItem'
import ListItemText from '../basic-components/ListItemText'
import Modal from '../basic-components/Modal'

import ArrowCircleRightIcon from '../icons/ArrowCircleRightIcon'
import BackIcon from '../icons/BackIcon'
import CheckIcon from '../icons/CheckIcon'
import EnvelopeIcon from '../icons/EnvelopeIcon'
import IconContainer from '../icons/IconContainer'
import ListIcon from '../icons/ListIcon'
import TrashIcon from '../icons/TrashIcon'

import ConfirmDialog from './ConfirmDialog'

import NotesContext from '../context/NotesContext'


export default function NotesPage({
  editingList, setEditingList,
  onBackClick, onItemClick, onSendEmailClick
}) {
  //console.warn('*** rendering NotesPage *****************');

  const { notes, setNotes, noteStore } = useContext(NotesContext);

  const [ modalOpen, setModalOpen ] = useState(false);

  // backClick handler for when editing
  const backClickHandler = () => { setEditingList(false); }

  const checkClickHandler = (e) => {
    //console.log(e.target);
    //console.log(e.target.parentNode);
    const id = e.target.parentNode.id;
    const changedNote = {...notes[id], checked: !notes[id].checked};
    setNotes({ ...notes, [id]:changedNote })
  }

  const checkAllClickHandler = () => {
    const someUnchecked = Object.values(notes).filter(note => !note.checked);
    //console.log(someUnchecked);

    const newValueForAll = (someUnchecked.length === 0) ? false : true;
    //console.log(newValueForAll);
    setNotes(Object.keys(notes).reduce((accumulator, id) => {
      const changedNote = {...notes[id], checked: newValueForAll};
      return { ...accumulator, [id]: changedNote }
    }, {}));
  }

  const envelopeClickHandler = () => {
    // go to email notes page
    // pass checked or array on checked notes
    //console.warn('envelope click...');
    onSendEmailClick();
  }

  const itemClickHandler = (e) => {
    const id = e.target.parentNode.id;
    onItemClick(id);
  }

  const listClickHandler = () => { setEditingList(true); }

  const noClickHandler = () => { setModalOpen(false); }

  const trashClickHandler = () => { setModalOpen(true); }

  const yesClickHandler = () => {
    // delete checked notes
    const ids = Object.keys(notes);
    const remainingNotes = {};
    ids.forEach((id, i) => {
      if (notes[id].checked) {
        noteStore.deleteNote(notes, id);
      } else {
        remainingNotes[id] = notes[id];
      }
    });
    //console.log(remainingNotes);
    setNotes(remainingNotes);
    setModalOpen(false);
  }

  const noteIds = Object.keys(notes);

  //console.log(notes);
  //console.log(noteIds);

  let noteList;
  if (noteIds.length === 0) {
    noteList = (
      <p>
        No Notes found.
      </p>
    );
  } else {
    noteList = (
      <List>
        {noteIds.map((id, i) => {
          const note = notes[id];
          return (
              <ListItem key={id} id={id} onClick={editingList ? checkClickHandler : itemClickHandler} >
                {editingList ? (
                  <Checkbox>
                    {!note.checked ? null : (
                      <CheckIcon
                        transform="up-10 left-6"
                        style={{ pointerEvents: 'none'}}
                      />
                    )}
                  </Checkbox>
                 ) : null}
                <ListItemText>&nbsp;#{id + ' - ' + note.title}</ListItemText>
                {editingList ? null :  (
                  <ArrowCircleRightIcon style={{pointerEvents: 'none'}}/>
                )}
              </ListItem>
          );
        })}
      </List>
    )
  }

  const someChecked = (noteIds.filter(id => notes[id].checked).length !== 0);
  //console.log(someChecked);

  return (
    <>
    <Container>
      <Header>
        <IconContainer>
          <BackIcon onClick={editingList ? backClickHandler : onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Notes</strong></HeaderTitle>
        <IconContainer>
          {editingList ? null : (<ListIcon onClick={listClickHandler}/>)}
        </IconContainer>
      </Header>

      <Content>
        {noteList}
      </Content>

      {editingList ? (
        <Footer>
          <IconContainer style={{flex: '1 0 auto'}}>
            <CheckIcon
              size="2x"
              transform="down-3"
              onClick={checkAllClickHandler}
            />
            <EnvelopeIcon
              isDisabled={!someChecked}
              onClick={envelopeClickHandler}
            />
            <TrashIcon
              isDisabled={!someChecked}
              onClick={trashClickHandler}
            />
          </IconContainer>
        </Footer>
       ) : null}

    </Container>

    <Modal
      open={modalOpen}
      showCloseIcon={false}
      closeOnOverlayClick={false}
      onClose={() => setModalOpen(false)}
    >
      <ConfirmDialog
        question={'Do you really want to delete the Note(s)?'}
        onNoClick={noClickHandler}
        onYesClick={yesClickHandler}
      />
    </Modal>
    </>
  );
}
